import { $authHost } from "../../http";
import { 
    MEDICAL_ORDER_GET_REQUEST, MEDICAL_ORDER_GET_SUCCESS, MEDICAL_ORDER_GET_ERROR, 
    MEDICAL_ORDER_GET_BY_KEY_REQUEST, MEDICAL_ORDER_GET_BY_KEY_SUCCESS, MEDICAL_ORDER_GET_BY_KEY_ERROR, 
    MEDICAL_ORDER_ADD_REQUEST, MEDICAL_ORDER_ADD_SUCCESS, MEDICAL_ORDER_ADD_ERROR, 
    MEDICAL_ORDER_EDIT_REQUEST, MEDICAL_ORDER_EDIT_SUCCESS, MEDICAL_ORDER_EDIT_ERROR, 
    MEDICAL_ORDER_DELETE_REQUEST, MEDICAL_ORDER_DELETE_SUCCESS, MEDICAL_ORDER_DELETE_ERROR
} from "../constants/medicalOrderConstants";

export const getMedicalOrders = (args) => async (dispatch) => {
    try {
        dispatch({
            type: MEDICAL_ORDER_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/medicalOrder/query",
            args || {},
            config,
        );
        dispatch({
            type: MEDICAL_ORDER_GET_SUCCESS,
            payload: data.result,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: MEDICAL_ORDER_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getMedicalOrderByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: MEDICAL_ORDER_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/medicalOrder/${id}`,
        );
        dispatch({
            type: MEDICAL_ORDER_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data.result;
    } catch (error) {
        dispatch({
            type: MEDICAL_ORDER_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addMedicalOrder = ({ name, code, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: MEDICAL_ORDER_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/medicalOrder",
            { name, code, description },
            config,
        );
        dispatch(getMedicalOrders(queryArgs || {}));
        dispatch({
            type: MEDICAL_ORDER_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: MEDICAL_ORDER_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const editMedicalOrder = ({ id, name, code, description }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: MEDICAL_ORDER_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/medicalOrder",
            { id, name, code, description },
            config,
        );
        dispatch(getMedicalOrders(queryArgs || {}));
        dispatch({
            type: MEDICAL_ORDER_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: MEDICAL_ORDER_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteMedicalOrder = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: MEDICAL_ORDER_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/medicalOrder",
            { data: { id } },
            config,
        );
        dispatch(getMedicalOrders(queryArgs || {}));
        dispatch({
            type: MEDICAL_ORDER_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: MEDICAL_ORDER_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

